import { render, staticRenderFns } from "./BaseChart.vue?vue&type=template&id=10c37a9e&scoped=true&"
import script from "./BaseChart.vue?vue&type=script&lang=ts&"
export * from "./BaseChart.vue?vue&type=script&lang=ts&"
import style0 from "./BaseChart.vue?vue&type=style&index=0&id=10c37a9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c37a9e",
  null
  
)

export default component.exports